/***
* Clipboard directive _ EJ
* copied from https://github.com/maxisam/ngx-clipboard/blob/master/src/clipboard.directive.ts
* need clipboard.js https://clipboardjs.com/
* used to copy some text from HTML DOM element
* plunker : https://plnkr.co/edit/8EN7SAYzMyAdq4UrU62W?p=preview
* howTo:
* <div #domElment>Texte à copier</div>
* <btn [ngxClipboard]="domElement"></btn>
* OR
* <btn ngxClipboard cbContent="variable"></btn>
***/

import { Directive, ElementRef, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';

import * as Clipboard from 'clipboard';

@Directive({
    selector: '[ngxClipboard]'
})
export class ClipboardDirective implements OnInit, OnDestroy {
    public clipboard: Clipboard;

    @Input('ngxClipboard')
    public targetElm: ElementRef;

    @Input()
    public cbContent: string;

    @Output('cbOnSuccess')
    public readonly onSuccess: EventEmitter<boolean> = new EventEmitter<boolean>();

    @Output('cbOnError')
    public readonly onError: EventEmitter<boolean> = new EventEmitter<boolean>();

    constructor(private elmRef: ElementRef) { }

    public ngOnInit(): void {
        let option: Clipboard.Options;
        option = !!this.targetElm ? { target: () => <any>this.targetElm } : { text: () => this.cbContent };
        this.clipboard = new Clipboard(this.elmRef.nativeElement, option);
        this.clipboard.on('success', () => this.onSuccess.emit(true));
        this.clipboard.on('error', () => this.onError.emit(true));
    }

    public ngOnDestroy(): void {
        if (this.clipboard) {
            this.clipboard.destroy();
        }
    }
}
